<form id="llmConfigurationForm" [formGroup]="llmConfigurationForm" (submit)="onSubmitForm()">
  <ca-compact-form-body [mainContainerClass]="''">
    <ng-template form-row>
      <div class="col-4">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="name">
            {{ '::Name' | abpLocalization }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="name" formControlName="name" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="llmProviderId">
            {{ 'Settings::LLMConfiguration:Provider' | abpLocalization }}
          </ca-form-label>
          <ca-select
            [class]="'below-all'"
            id="llmProviderId"
            formControlName="llmProviderId"
            [disabled]="llmConfiguration?.id > 0"
            (change)="onProviderChange($event)">
            <ca-option *ngFor="let llmProvider of llmProviders" [value]="llmProvider.id">
              {{ 'GenericLookup::' + llmProvider.code | abpLocalization }}
            </ca-option>
          </ca-select>
        </ca-compact-form-item>
      </div>
    </ng-template>
    <ng-template form-row>
      <div class="col-4" *ngIf="requiresApiKey">
        <ca-compact-form-item>
          <ca-form-label
            [ngClass]="llmConfiguration?.id === 0 ? 'indicates-required-field' : ''"
            for="apiKey">
            {{
              (isAwsBedrockProvider
                ? 'Settings::LLMConfiguration:AwsSecretAccessKey'
                : isVertexAiProvider
                  ? 'Settings::LLMConfiguration:VertexAiPrivateKey'
                  : 'Settings::LLMConfiguration:APIKey'
              ) | abpLocalization
            }}
          </ca-form-label>
          <ca-form-input>
            <input
              type="password"
              class="form-control form-control-sm"
              id="apiKey"
              formControlName="apiKey"
              [placeholder]="
                llmConfiguration?.id > 0
                  ? ('Settings::MaskedAreaPlaceholder' | abpLocalization)
                  : ''
              " />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="isAzureProvider || isProxyProvider || isAwsBedrockProvider || isPrivateLLMProvider || isVertexAiProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="resourceName">
            {{
              (isAwsBedrockProvider
                ? 'Settings::LLMConfiguration:AwsAccessKeyId'
                : isVertexAiProvider
                  ? 'Settings::LLMConfiguration:VertexAiProjectId'
                  : 'Settings::LLMConfiguration:APIBase'
              ) | abpLocalization
            }}
          </ca-form-label>
          <ca-form-input>
            <input
              type="text"
              id="resourceName"
              formControlName="resourceName"
              [placeholder]="
                isProxyProvider
                  ? ('Settings::LLMConfiguration:ProxyApiBasePlaceholder' | abpLocalization)
                  : ''
              " />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="isDynamicModelProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="generativeAIModel">
            {{ 'Settings::LLMConfiguration:OpenAIModel' | abpLocalization }}
          </ca-form-label>
          <div class="d-flex gap-1 align-items-center">
            <ca-select
              class="flex-fill"
              [class]="'below-all'"
              formControlName="generativeAIModel"
              id="generativeAIModel">
              <ca-option *ngFor="let model of activeModelList" [value]="model">
                {{ model }}
              </ca-option>
            </ca-select>
            <button
              type="button"
              class="btn btn-sm btn-secondary"
              [disabled]="fetchingActiveProviderModels"
              (click)="onFetchActiveProviderModels()">
              {{ 'Settings::LLMConfiguration:FetchModels' | abpLocalization }}
            </button>
          </div>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="isAzureProvider || isVertexAiProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="deploymentName">
            {{
              (isVertexAiProvider
                ? 'Settings::LLMConfiguration:VertexAiClientEmail'
                : 'Settings::LLMConfiguration:DeploymentName'
              ) | abpLocalization
            }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="deploymentName" formControlName="deploymentName" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="isPrivateLLMProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="generativeAIModel">
            {{ 'Settings::LLMConfiguration:OpenAIModel' | abpLocalization }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="generativeAIModel" formControlName="generativeAIModel" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
    </ng-template>
    <ng-template form-row>
      <div class="col-4" *ngIf="isAzureProvider || isAwsBedrockProvider || isVertexAiProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="apiVersion">
            {{
              (isAwsBedrockProvider
                ? 'Settings::LLMConfiguration:AwsRegion'
                : isVertexAiProvider
                  ? 'Settings::LLMConfiguration:VertexAiLocation'
                  : 'Settings::LLMConfiguration:APIVersion'
              ) | abpLocalization
            }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="apiVersion" formControlName="apiVersion" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="isVertexAiProvider">
        <ca-compact-form-item>
          <ca-form-label class="indicates-required-field" for="tokenUri">
            {{ 'Settings::LLMConfiguration:VertexAiTokenUri' | abpLocalization }}
          </ca-form-label>
          <ca-form-input>
            <input type="text" id="tokenUri" formControlName="tokenUri" />
          </ca-form-input>
        </ca-compact-form-item>
      </div>
      <div class="col-4" *ngIf="supportsReasoningEffort">
        <ca-compact-form-item>
          <ca-form-label for="reasoningEffort">
            {{ 'Settings::LLMConfiguration:ReasoningEffort' | abpLocalization }}
          </ca-form-label>
          <ca-select [class]="'below-all'" formControlName="reasoningEffort" id="reasoningEffort">
            <ca-option value="default">
              {{ 'Settings::LLMConfiguration:ReasoningEffort:Default' | abpLocalization }}
            </ca-option>
            <ca-option value="none">
              {{ 'Settings::LLMConfiguration:ReasoningEffort:None' | abpLocalization }}
            </ca-option>
            <ca-option value="low">
              {{ 'Settings::LLMConfiguration:ReasoningEffort:Low' | abpLocalization }}
            </ca-option>
            <ca-option value="medium">
              {{ 'Settings::LLMConfiguration:ReasoningEffort:Medium' | abpLocalization }}
            </ca-option>
            <ca-option value="high">
              {{ 'Settings::LLMConfiguration:ReasoningEffort:High' | abpLocalization }}
            </ca-option>
          </ca-select>
        </ca-compact-form-item>
      </div>
    </ng-template>
    <ng-template form-row>
      <ca-compact-form-spacer></ca-compact-form-spacer>
    </ng-template>
  </ca-compact-form-body>
  <ca-compact-form-footer
    [processing]="processing"
    [buttons]="formButtonConfiguration"
    [processingMessage]="processingMessage"
    (deleteButtonClick)="confirmDeletion($event, llmConfiguration.name)"
    (cancelButtonClick)="closePanel()"></ca-compact-form-footer>
</form>
